const initialState = {
  authPdfPrint: false,
};

export default initialState;
